import { Field } from 'redux-form';

import * as T from '@components/form/RemoteAutoComplete/_remoteAutoCompleteTypes';
import { mapProps, compose } from 'recompose';
import RemoteAutoCompleteView from './RemoteAutocompleteView';
import muiThemeable from 'material-ui/styles/muiThemeable';

const enhance = compose<T.InnerProps, T.OutterProps>(
  mapProps(({ filterActive, params = { filter: [] }, ...rest }) => ({
    params: {
      ...params,
      pageSize: 999,
      filter: filterActive
        ? [
            {
              field: 'active',
              operation: 'EQ',
              value: true
            },
            ...params.filter
          ]
        : params.filter,
      sorting: filterActive
        ? [
            {
              sort: 'order',
              order: 'ASC'
            },
            {
              sort: 'name',
              order: 'ASC'
            }
          ]
        : []
    },

    ...rest
  })),
  muiThemeable()
);

export default enhance(RemoteAutoCompleteView);

export class RemoteAutoCompleteField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/RemoteAutoComplete/RemoteAutoComplete.tsx